import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const VVTimePickerStyle = (theme: Theme) =>
  createStyles({
    timePicker: {
      padding: "0px 30px",
      overflow: "hidden",
      maxHeight: "170px",
      display: "flex",
      alignSelf: "flex-end",
      transition: "max-height 0.3s, min-height 0.3s",
      userSelect: "none",
    },

    timepickerViewport: {
      position: "relative",               // <<< needed for absolutely-positioned children
      display: "flex",
      maxWidth: "170px",                  // match your inline usage
      maxHeight: "170px",
      perspective: "800px",
      WebkitPerspective: "800px",
      fontSize: "20px",
      lineHeight: "34px",
      width: "100%",
      textAlign: "center",
      fontWeight: 500,
    },

    scrollPane: {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex:2,
      opacity: 0,                         // invisible but still hit-testable
      overflowY: "auto",
      overflowX: "hidden",
      maxHeight: "170px",
      width: "70px",                      // <<< make each column easy to hit
      // smooth/controlled scrolling across devices
      WebkitOverflowScrolling: "touch",   // iOS momentum
      overscrollBehavior: "contain",      // don`t bubble to page
      touchAction: "pan-y",
      scrollSnapType: "y proximity",
      // optional: hide scrollbars (keeps layout stable)
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
    },

    scrollOption: {
      minHeight: "34px",
      lineHeight: "34px",
      minWidth: "70px",                   // match column width
      margin: 0,
      fontSize: "20px",
      fontWeight: 400,
      scrollSnapAlign: "center",
    },

    dateScrollOption: {
      width: "250px",
    },

    wheelMarker: {
      paddingLeft: "55px",
      textAlign: "left",
      pointerEvents: "none",              // <<< let scroll panes take input
      position: "absolute",
      backgroundColor: styleColors.greyLight2,
      width: "70px",
      top: "68px",
      zIndex: 1,
      left: "-10px",
      height: "34px",
      borderRadius: "10px",
      transition: "background-color 0.2s",
    },

    wheel: {
      pointerEvents: "none",
      position: "relative",
      width: "70px",                      // align with scroll columns
      height: "170px",
      zIndex: 1,
      transformStyle: "preserve-3d",
      WebkitTransformStyle: "preserve-3d",
      transformOrigin: "50% 50%",
      WebkitTransformOrigin: "50% 50%",
    },

    option: {
      minHeight: "34px",
      lineHeight: "34px",
      position: "absolute",
      top: "68px",
      color: styleColors.greyMedium1,
      left: "12px",
      margin: 0,
      fontSize: "20px",
      fontWeight: 400,
      WebkitBackfaceVisibility: "hidden",
      backfaceVisibility: "hidden",
      transformStyle: "preserve-3d",
      WebkitTransformStyle: "preserve-3d",
    },

    dateOption: { whiteSpace: "nowrap" },
    monthOption: { whiteSpace: "nowrap", left: "auto" },
    yearOption: { whiteSpace: "nowrap" },

    fullDay: {
      fontSize: "20px",                   // fix: was `fontsize`
      padding: "5px 12px",
      borderRadius: "10px",
      margin: "5px",
      justifySelf: "center",
      backgroundColor: styleColors.white,
      color: styleColors.greyMedium1,
      transition: "background-color 0.2s, color 0.2s",
    },
    fullDaySelected: {
      fontSize: "20px",                   // fix: was `fontsize'
      padding: "5px 12px",
      borderRadius: "10px",
      margin: "5px",
      justifySelf: "center",
      backgroundColor: styleColors.greyLight2,
      transition: "background-color 0.2s, color 0.2s",
    },
  });



// WEBPACK FOOTER //
// ./src/components/common/timepicker/timepicker.style.ts